import {
  TIPTAP_ACTION_BUTTON_TYPE,
  TIPTAP_FIGURE_TYPE,
  TIPTAP_LINK_BUTTON_TYPE,
} from './../../ricos-content/index.js';
import { Node_Type } from './../../ricos-schema/legacy/wix/rich_content/v1/index.js';

export const isNodeSpaced = (nodeType: string): boolean =>
  CLOSED_FOR_SPACING_TYPES.includes(nodeType);

const CLOSED_FOR_SPACING_TYPES: readonly (Node_Type | string)[] = [
  TIPTAP_FIGURE_TYPE,
  TIPTAP_LINK_BUTTON_TYPE,
  TIPTAP_ACTION_BUTTON_TYPE,
  Node_Type.IMAGE,
  Node_Type.VIDEO,
  Node_Type.GALLERY,
  Node_Type.DIVIDER,
  Node_Type.HTML,
  Node_Type.EMBED,
  Node_Type.FILE,
  Node_Type.GIF,
  Node_Type.AUDIO,
  Node_Type.POLL,
  Node_Type.BUTTON,
  Node_Type.ORDERED_LIST,
  Node_Type.BULLETED_LIST,
  Node_Type.LIST_ITEM,
  Node_Type.LINK_PREVIEW,
  Node_Type.APP_EMBED,
  Node_Type.CODE_BLOCK,
  Node_Type.BLOCKQUOTE,
  Node_Type.TABLE,
  Node_Type.TABLE_CELL,
  Node_Type.LAYOUT,
  Node_Type.LAYOUT_CELL,
  Node_Type.COLLAPSIBLE_LIST,
  Node_Type.COLLAPSIBLE_ITEM_BODY,
] as const;
